import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser } from "@fortawesome/free-solid-svg-icons";
import "../commons/NavbarTechnician.css";
import { NavLink } from "react-router-dom";

class NavbarDownConsumer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <nav
          id="navbarConsumer"
          className="navbar navbar-expand-lg navbar-dark bg-dark fixed-bottom"
        >
          <div className="container text-center navbInferior">
            <div className="home">
              <NavLink to="/home">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faHome} />
                </span>
                <span style={{ display: "block" }}> Home</span>
              </NavLink>
            </div>
            <div className="profile">
              <NavLink to="/view_profile">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faUser} />
                </span>
                <span style={{ display: "block" }}>Profile</span>
              </NavLink>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}
export default NavbarDownConsumer;
